import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Pill, BookHeart, Settings, PawPrint,
} from 'lucide-react';
import BeanIcon from './Custom Icons/KodaIcon';
import { NavLink } from './NavLink';
import { useLanguage } from '../functions/useLanguage';
import { useBean } from '../context/BeanContext';
import { useData } from '../context/DataContext';
import { cn } from '../lib/utils';

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth < 1024);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function NavPill({ profile, t, location, walkthroughActive, pendingUploadCount }: any) {
  return (
    <div className="flex items-end" style={{ paddingBottom: 'calc(env(safe-area-inset-bottom))' }}>
      {/* White pill — 4 nav links only */}
      <div className={cn("flex-1 flex items-center justify-evenly h-[68px] bg-white overflow-visible", walkthroughActive ? 'pr-0' : 'pr-20')}>
          <NavLink to="/vitals" icon={<PawPrint size={24} />} label={t('nav.records')} active={location.pathname === '/vitals'} dataTour="nav-records" />
          <NavLink to="/meds" icon={<Pill size={24} />} label={t('nav.meds')} active={location.pathname === '/meds'} dataTour="nav-meds" />
          <NavLink to="/library" icon={<BookHeart size={24} />} label={t('nav.guide')} active={location.pathname.startsWith('/library')} dataTour="nav-guide" badge={pendingUploadCount || undefined} />
        <NavLink to="/settings" icon={<Settings size={24} />} label={t('account.title')} active={location.pathname.startsWith('/settings')} />
      </div>
      {/* Bean sits alongside the pill — hidden during walkthrough */}
      {!walkthroughActive && (
        <Link to="/kodafellowship" data-tour="nav-bean" className="flex-shrink-0 flex items-end opacity-100 transition-opacity -ml-[90px]">
          <BeanIcon width={90} height={90} style={{ transform: 'scaleX(-1)' }} beanColor={profile?.roomie_color ?? undefined} />
        </Link>
      )}
    </div>
  );
}

export function BottomBar({ walkthroughActive }: { walkthroughActive?: boolean }) {
  const location = useLocation();
  const { t } = useLanguage();
  const { profile } = useBean();
  const { pendingUploadCount } = useData();
  const isMobile = useIsMobile();

  if (location.pathname === '/bean') return null;
  if (!isMobile) return null;

  return (
    <div className="w-full lg:hidden">
      <div className="-mt-6">
        <NavPill profile={profile} t={t} location={location} walkthroughActive={walkthroughActive} pendingUploadCount={pendingUploadCount} />
      </div>
    </div>
  );
}
